<template>
  <div class="total-score-distribution">
    <el-table v-if="totalScoreDistributionShow" :data="transformedData" border style="width: 100%"
      height="calc(100vh - 260px)">
      <el-table-column prop="scoreRange" label="分数段" width="100"></el-table-column>
      <!-- 动态生成班级列 -->
      <el-table-column v-for="(className, index) in classNames" :key="index" :prop="className" :label="className">
      </el-table-column>
      <el-table-column prop="total" label="全级"></el-table-column>
    </el-table>
    <div class="rank-text" v-else>请输入分数间隔和截止分数查询</div>
  </div>
</template>

<script>
export default {
  props: ['totalScoreDistributionShow', 'totalScoreDistributionList'],
  data() {
    return {
      tableData: [
        { scoreRange: '<250', class1: 0, class2: 0, class3: 0, class4: 0, total: 0 },
        { scoreRange: '>=270', class1: 0, class2: 0, class3: 0, class4: 0, total: 0 },
        { scoreRange: '>=300', class1: 0, class2: 0, class3: 0, class4: 0, total: 0 },
      ]
    };
  },
  computed: {
    // 使用computed属性来处理数据转换
    transformedData() {
      let classMap = {};
      let classNames = [];
      this.totalScoreDistributionList.forEach(item => {
        if (item.className !== '全级') {
          classMap[item.className] = item.className;
          classNames.push(item.className);
        }
      });

      const allLevelData = this.totalScoreDistributionList.find(item => item.classId === -1);
      const scoreRanges = allLevelData.branchSegments ? Object.keys(allLevelData.branchSegments) : [];

      // 初始化transformedData，包括所有的分数段，并为每个班级创建初始值0
      let result = scoreRanges.map(scoreRange => ({
        scoreRange,
        ...Object.fromEntries(classNames.map(className => [className, 0])),
        total: 0
      }));

      // 处理每个班级的数据
      this.totalScoreDistributionList.forEach(item => {
        if (item.branchSegments && item.className !== '全级') {
          Object.keys(item.branchSegments).forEach(scoreRange => {
            // 更新对应的分数段的值
            result.find(item => item.scoreRange === scoreRange)[item.className] = item.branchSegments[scoreRange];
          });
        }
      });

      // 使用全级的数据来填充total字段
      if (allLevelData && allLevelData.branchSegments) {
        Object.keys(allLevelData.branchSegments).forEach(scoreRange => {
          result.find(item => item.scoreRange === scoreRange).total = allLevelData.branchSegments[scoreRange];
        });
      }

      this.totalScoreDistributionShow = true; // 显示表格

      return result;
    },
    classNames() {
      return this.totalScoreDistributionList
        .filter(item => item.className !== '全级')
        .map(item => item.className);
    }
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "./totalScoreDistribution.scss";
</style>